import React, { useState } from 'react';
import { Tabs } from '@roo/roo';
import UnallocatedTable from './componets/unallocatedStore';
import AllocatedTable from './componets/allocatedStore';

const { Pane: TabPane } = Tabs;

const Store: React.FC = () => {
    const [currentPage, setCurrentPage] = useState('unallocated');

    const handleTabClick = tab => {
        setCurrentPage(tab);
    };

    return (
        <div className="page">
            <Tabs type="line" value={currentPage} onTabClick={handleTabClick}>
                <TabPane label="待分配门店" name="unallocated">
                    <UnallocatedTable />
                </TabPane>
                <TabPane label="已分配门店" name="allocated">
                    {currentPage === 'allocated' ? <AllocatedTable /> : null}
                </TabPane>
            </Tabs>
        </div>
    );
};

export default Store;
